import PropTypes from 'prop-types'
import { makeStyles, Popover } from '@material-ui/core'
import React, { useCallback, useMemo, useState } from 'react'
import clsx from 'clsx'
import Icon from '../../../atoms/Icon'
import { defaultVisibilityLabel } from '../constants'
import { useVaultContext } from '../VaultContextProvider'

const useStyles = makeStyles(() => ({
  iconsContainer: {
    position: 'absolute',
    top: '.5rem',
    right: '.5rem',
    display: 'flex',
    zIndex: 100
  },
  iconsContainerInline: {
    display: 'flex'
  },
  iconElement: {
    background: 'color-mix(in srgb, var(--color-primary-500) 80%, transparent)',
    borderRadius: 'var(--border-radius-round)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 0,
    padding: '8px'
  },
  popoverRoot: {
    pointerEvents: 'none'
  },
  popoverContent: {
    padding: '.5rem',
    background: 'var(--color-primary-500)',
    color: 'var(--color-primary-050)',
    borderRadius: 'var(--border-radius-sm)',
    marginTop: '4px'
  }
}))

const VisibilityIcon = ({ visibility, labels: _labels, inline = false, iconSize = '18px' }) => {
  const { labels: contextLabels } = useVaultContext()
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)
  const isOpen = Boolean(anchorEl)

  const handleMouseEnter = useCallback((e) => setAnchorEl(e.currentTarget), [setAnchorEl])
  const handleMouseLeave = useCallback(() => setAnchorEl(null), [setAnchorEl])

  const label = useMemo(() => {
    return {
      ...(defaultVisibilityLabel?.[visibility] ?? {}),
      ...(contextLabels?.visibility?.[visibility] ?? {}),
      ...(_labels?.visibility?.[visibility] ?? {})
    }
  }, [_labels, visibility, contextLabels?.visibility])

  if (!Object.keys(label)?.length) return null

  return (
    <div
      className={clsx({
        [classes.iconsContainer]: !inline,
        [classes.iconsContainerInline]: inline
      })}
    >
      <div
        className={classes.iconElement}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Icon
          name={label.icon}
          customSize={iconSize}
          color='var(--color-primary-050)'
        />
      </div>
      {label?.label?.length && (
        <Popover
          open={isOpen}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          classes={{
            root: classes.popoverRoot,
            paper: classes.popoverContent
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}
          disableRestoreFocus
        >
          {label.label}
        </Popover>
      )}
    </div>
  )
}
VisibilityIcon.propTypes = {
  visibility: {
    visibility: PropTypes.object
  },
  labels: PropTypes.object,
  inline: PropTypes.bool,
  iconSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default VisibilityIcon
